var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1078)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8065 0H5.19355C2.32523 0 0 2.32523 0 5.19355V40.8065C0 43.6748 2.32523 46 5.19355 46H40.8065C43.6748 46 46 43.6748 46 40.8065V5.19355C46 2.32523 43.6748 0 40.8065 0Z",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1035_1078",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9107 9.64502H9.64453V36.9111H36.9107V9.64502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1035_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2763 9.64502C17.8273 9.64502 13.4102 14.0623 13.4102 19.5111C13.4102 27.3645 23.2763 36.9111 23.2763 36.9111C23.2763 36.9111 33.1422 27.3645 33.1422 19.5111C33.1422 14.0623 28.725 9.64502 23.2763 9.64502ZM23.2763 26.7105C19.3001 26.7105 16.0768 23.4872 16.0768 19.5111C16.0768 15.535 19.3001 12.3117 23.2763 12.3117C27.2523 12.3117 30.4756 15.5349 30.4756 19.5111C30.4756 23.4871 27.2523 26.7105 23.2763 26.7105ZM27.2372 17.1616H26.9316V16.1578C26.9316 15.3872 26.2593 14.9933 25.5199 14.9933H21.0325C20.293 14.9933 19.6208 15.3872 19.6208 16.1578V17.1616H19.3152C19.1208 17.1616 18.9632 17.3143 18.9632 17.5027V19.2311C18.9632 19.4195 19.1208 19.5722 19.3152 19.5722H19.6208V22.3747H19.99V23.1351C19.99 23.4025 20.2137 23.6192 20.4896 23.6192H21.1707C21.4467 23.6192 21.6703 23.4025 21.6703 23.1351V22.3747H24.8627V23.1351C24.8627 23.4025 25.0864 23.6192 25.3623 23.6192H26.0434C26.3193 23.6192 26.5429 23.4025 26.5429 23.1351V22.3747H26.9316V19.5722H27.2372C27.4316 19.5722 27.5892 19.4195 27.5892 19.2311V17.5027C27.5891 17.3143 27.4315 17.1616 27.2372 17.1616ZM20.7364 21.6858C20.4117 21.6858 20.1485 21.4307 20.1485 21.1161C20.1485 20.8013 20.4117 20.5462 20.7364 20.5462C21.0611 20.5462 21.3244 20.8013 21.3244 21.1161C21.3244 21.4307 21.0611 21.6858 20.7364 21.6858ZM22.8566 19.6492H20.2417V16.6177H22.8566V19.6492ZM23.6958 19.6492V16.6177H26.3106V19.6492H23.6958ZM25.8159 21.6858C25.4912 21.6858 25.2279 21.4307 25.2279 21.1161C25.2279 20.8013 25.4912 20.5462 25.8159 20.5462C26.1406 20.5462 26.4038 20.8013 26.4038 21.1161C26.4038 21.4307 26.1406 21.6858 25.8159 21.6858Z",
    fill: "#7E807E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/Shipped.818271badfec42ac78f71204e1d732d4.svg";
export { ForwardRef as ReactComponent };